// @ts-ignore
import { AppConst } from "../common/app-constants.ts";

const LOGO_URL = AppConst.APP_LOGO_URL;

export default function AppLogo() {
  return <AppLogoImage />;
}

const AppLogoImage = () => {
  return (
    <p>
      <img src={LOGO_URL} width="64px" alt={`${AppConst.APP_NAME} logo`} />
    </p>
  );
};
